<template lang="pug">
.wrap
 .content.color_bg_vip_1
    Equity
    .vip-container
      img.close(src='@/assets/imgs/vip/ic_close.png' @click='closeVip')
      login(:isSVip="isSVip" :isLogin="isLogin" :userInfo="userInfo" :vipInfo="vipInfo")
      buyContent(:isSVip="isSVip" :isLogin="isLogin" :vipInfo="vipInfo")
      bottomToolbarVue(:isSVip="isSVip" :isLogin="isLogin")
</template>

<script>
import util from '@/util';
import login from '@/components/login.vue';
import buyContent from '@/components/buyContent.vue';
import Equity from '@/components/Equity.vue';
import vip from '@/service/vip';
import serviceLogin from '@/service/login/index';
import bottomToolbarVue from './bottomToolbar.vue';

export default {
  name: 'buyVip',
  components: {
    buyContent,
    login,
    Equity,
    bottomToolbarVue,
  },
  data() {
    return {
      isSVip: false,
      isLogin: false,
      vipInfo: {},
      userInfo: {
        userAvatar: '', // 用户头像
        userName: '',
        svipExpire: '',
      },
    };
  },
  mounted() {
    this.getVipStatus();
    this.getAccountInfo();
    const keyfrom = util.getQueryVariable('keyfrom') || util.getQueryVariable('source');
    window._rlog.push(['_trackCustom', 'event', [keyfrom ? ['keyfrom', keyfrom] : '', ['type', util.getPlatform()], ['show', 'cidian_vip_purchase']]]);
  },
  methods: {
    closeVip() {
      this.$emit('closeVip');
    },
    // 获取用户头像昵称
    getBatchData(userid) {
      const params = {
        userid,
      };
      serviceLogin.getBatchUrl(params).then((res) => {
        this.userInfo.userName = res.values.nickname;
        this.userInfo.userAvatar = res.values.option_avatar;
      });
    },
    // 获取用户信息
    getAccountInfo() {
      serviceLogin
        .getAccountInfos()
        .then((res) => {
          if (res.code === 0) {
            this.isLogin = true;
            this.yduserid = res.data.yduserid;
            this.getBatchData(this.yduserid);
          } else {
            this.isLogin = false;
            this.yduserid = '';
          }
        })
        .catch((e) => {
          console.log('获取账户信息失败', e);
        });
    },
    getVipStatus() {
      const param = {
        imei: '1',
        keyfrom: 'webdict',
        apiversion: '1.0',
        product: '',
      };
      vip.getVipStatus(param).then((res) => {
        this.isSVip = res.svip;
        this.vipInfo = res;
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.wrap
  position fixed
  top 0
  right 0
  width 100%
  height 100%
  background rgba(9, 11, 15, 0.2)
  display flex
  justify-content center
  align-items center
  z-index 999
  .content
    width 910px
    height 640px
    border-radius 10px
    position relative
    display flex
    .close
      position absolute
      right 25px
      top 7px
      width 16px
      height 16px
      cursor pointer
    .vip-container
      width calc(100% - 275px - 56px) // 64px是vipContainer的padding
      border-radius 10px
      padding 26px 28px 0 28px
      font-family 'PingFang SC'
      background url('./../assets/imgs/vip/light/bg_light.png') 0 0 / 100% no-repeat
      position relative
</style>
